var render = function render(){var _vm=this,_c=_vm._self._c;return _c('popper',{staticClass:"default-poper",attrs:{"trigger":"clickToOpen","options":{
    placement: 'top',
    modifiers: { offset: { offset: '-50px,10px' } },
  }}},[_c('div',{staticClass:"popper"},[_c('ul',_vm._l((_vm.list),function(item,index){return _c('li',{key:index,staticClass:"item",on:{"click":function($event){return _vm.onClick(item)}}},[_c('van-icon',{staticClass:"icon",attrs:{"color":"#fff","name":item.icon}}),_c('div',{staticClass:"title"},[_vm._v(_vm._s(item.title))])],1)}),0)]),_c('icon',{attrs:{"slot":"reference","title":"DMiconzhuanqu-"},slot:"reference"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }